module.exports = __webpack_public_path__ + "img/medium-icon.6592b94c.png";